import React, { useRef, useEffect } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import CardWitTitle from './CardWithTitle';

function ApplicationSupportingDocuments({ supportingDocuments, submission, onChange, ...props }) {

  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return (
      () => {
        isMounted.current = false;
      }
    );
  }, []);

  const handleChange = (event) => {
    const name = event.target.name;
    let key = null;
    const value = event.target.checked;
    switch (name) {
      case 'approve-supporting-documents':
        key = 'approveSupportingDocuments';
      default:
        break;
    }
    const _submission = {
      ...submission,
      [key]: value,
    };
    onChange(_submission);
  };

  const useStyles = makeStyles(theme => ({
    photo: {
      width: '100%',
      padding: 20
    }
  }));

  const classes = useStyles();

  return (
    <React.Fragment>
      <CardWitTitle title="Dokument som styrker inkomst" onChange={handleChange} checked={submission?.approveSupportingDocuments} name='approve-supporting-documents'>
        <Grid container spacing={2}>
          {
            supportingDocuments?.map(document => (
              document &&
              <Grid item xs={4} key={document.name}>
                {
                  document.mimeType?.startsWith('image/')
                    // Use URL until the new thumb generation has been out for a while, creating 
                    // long lived thumb urls. Should be possible to use thumbURL after 2023-01-12.
                    ? <a href={document.URL} target='_blank'><img src={document.URL} className={classes.photo} /></a>

                    : document.mimeType === 'application/pdf'
                      // Uploading PDF files is a new feature in mobile v1.5.0, 
                      // which will be released after the new thumb generation.
                      // So here we can use thumbURL right away.
                      ? <a href={document.URL} target='_blank'><img src={document.thumbURL} className={classes.photo} /></a>

                      : null
                }
              </Grid>
            ))
          }
        </Grid>
      </CardWitTitle>
    </React.Fragment>
  );
}

export default ApplicationSupportingDocuments;